import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { useTranslation } from "react-i18next";
import { Subheading } from "src/components/base/heading";
import SINGLE_SUBNET_CONTEXT from "src/context/internal/subnet";

/**
 * The properties for {@link SubnetOutboundACLs}
 */
export type SubnetOutboundACLsProps = {};

/**
 * Outbound ACLs of a group
 */
function SubnetOutboundACLs(props: SubnetOutboundACLsProps) {
    const [t] = useTranslation("admin-subnet-view");

    const ctx = React.useContext(SINGLE_SUBNET_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            <Subheading>{t("heading.add-new-acl")}</Subheading>
            <ACL
                key={"new-outbound"}
                onChange={ctx.reset}
                src={{ type: "Subnet", value: ctx.subnet }}
                startEditable={true}
            />

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.subnet.access_rules.outbound.map((acl) => (
                <ACL key={acl.uuid} src={acl.src} acl={acl} onChange={ctx.reset} />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/subnets/$subnetId/_subnet/outbound-acls")({
    component: SubnetOutboundACLs,
});
